import React from 'react';
import Card from "@mui/joy/Card";
import Typography from "@mui/joy/Typography";
import CardOverflow from "@mui/joy/CardOverflow";
import CardContent from "@mui/joy/CardContent";
import CardActionArea from '@mui/material/CardActionArea';
import AspectRatio from "@mui/joy/AspectRatio";

const VideoCard = (info) => {
    const data = info.info;
    return(
        <CardActionArea sx={{ '&:hover': {opacity: '85%'} }}>
            <Card variant="outlined" sx={{width:{md: 320, xs: 240}, border: '2px solid black', '&:hover': {opacity: '70%', outline:'2px solid #006494', outlineColor: '#006494', borderColor: '#006494'} }} onClick={ () => {window.open(`https://www.youtube.com/watch?v=${data[3].textContent}`)}}>
                <CardOverflow>
                    <AspectRatio ratio="2">
                        <img
                            src={`https://img.youtube.com/vi/${data[3].textContent}/0.jpg`}
                            // src="https://images.pexels.com/photos/372326/pexels-photo-372326.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                            loading="lazy"
                            alt=""
                        />
                    </AspectRatio>
                </CardOverflow>
                <CardContent>
                    <Typography level="title-md">{data[7].textContent}</Typography>
                    {/* <Typography level="body-sm">4301 Dalrock Rd, Rowlett, TX 75088</Typography> */}
                </CardContent>
                <CardOverflow variant="soft" sx={{ bgcolor: 'background.level1' }}>
                    {/* <Divider inset="context" />
                    <CardContent orientation="horizontal">
                        <Typography
                            level="body-xs"
                            textColor="text.secondary"
                            sx={{ fontWeight: 'md' }}
                        >
                            {formattedDate}
                        </Typography>
                    </CardContent> */}
                    
                </CardOverflow>
            </Card>
        </CardActionArea>
    );
}

export default VideoCard;